var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.64819,
    r: 6.5,
    fill: "#83C60D",
    fillOpacity: 0.44
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 11.375C9.19239 11.375 11.375 9.19239 11.375 6.5C11.375 3.80761 9.19239 1.625 6.5 1.625C3.80761 1.625 1.625 3.80761 1.625 6.5C1.625 9.19239 3.80761 11.375 6.5 11.375ZM9.08279 5.22177C9.2743 4.99195 9.24325 4.65039 9.01343 4.45888C8.78362 4.26737 8.44206 4.29842 8.25055 4.52823L6.30165 6.8669C6.11385 7.09227 6.00827 7.21704 5.92398 7.29371L5.92076 7.29663L5.91728 7.29401C5.8264 7.22529 5.70996 7.11059 5.50252 6.90315L4.71635 6.11698C4.50482 5.90545 4.16185 5.90545 3.95032 6.11698C3.73878 6.32852 3.73878 6.67148 3.95032 6.88302L4.73649 7.66919L4.7586 7.6913C4.93545 7.86822 5.10558 8.03842 5.26388 8.15812C5.44121 8.2922 5.67343 8.41829 5.97102 8.40479C6.26862 8.39129 6.48847 8.2447 6.65293 8.09511C6.79974 7.96157 6.95376 7.77668 7.11387 7.58448L7.11387 7.58447L7.13389 7.56044L9.08279 5.22177Z",
    fill: "#83C60D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircle);
export default __webpack_public_path__ + "static/media/tick-circle.d9032a477d802a6a27306c3ed1359afb.svg";
export { ForwardRef as ReactComponent };